import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-indigo-600 text-customOrange py-6">
      <div className="container mx-auto px-4">
        <div className="flex flex-col sm:flex-row justify-between items-center">
          <div className="text-center sm:text-left">
            <h4 className="text-xl font-semibold">Abinand Nanthananthan's Portfolio Website</h4>
            <p className="mt-2 text-sm">© 2025 Abinand Nanthananthan. All rights reserved.</p>
          </div>
          <div className="flex flex-wrap justify-center sm:justify-end mt-4 sm:mt-0">
            <a href="/contact" className="text-sm hover:text-gray-400 px-4">Contact</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
